module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row template-section"
  }, [_c('div', {
    staticClass: "col-lg-1 col-md-1"
  }, [_c('product-photo', {
    attrs: {
      "photo_link": _vm.photo_link
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 product-section"
  }, [_c('product-detail', {
    attrs: {
      "product_id": _vm.product_id,
      "product_name": _vm.product_name,
      "product_link": _vm.product_link,
      "shop_name": _vm.shop_name,
      "srp_price": _vm.srp_price
    }
  }), _vm._v(" "), _c('attributes', {
    attrs: {
      "attributesSelected": _vm.attributesSelected,
      "attributes": _vm.attributes
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 col-md-5"
  }, [_c('offers', {
    attrs: {
      "offers": _vm.offers
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b50defa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ProductAttribute/template.vue
// module id = 1272
// module chunks = 2